import "./index.css";
import { Input } from "antd";
import React, { useRef } from "react";

interface TypeInputTextAreaProps<T = string> {
  /**
   * @param texts 根据传入的文本，依次返回
   */
  texts: string[];
  value?: T;
  onChange?(value: T): void;
  rows?: number;
  allowClear?: boolean;
}

/**
 * @name InputTextArea 增加了 自动生成
 */
const InputTextArea: React.FC<TypeInputTextAreaProps> = ({
  rows = 4,
  texts,
  value,
  onChange,
}) => {
  const index = useRef(0);

  const onGetText = () => {
    const length = texts?.length;
    if (!length) return;
    const startIndex = index.current;
    do {
      const nextText = texts[index.current];
      index.current = (index.current + 1) % length;
      if (nextText !== value) {
        onChange?.(nextText);
        return;
      }
    } while (index.current !== startIndex);
  };

  function onInputChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    onChange?.(e.target.value);
  }

  return (
    <div className="input-text-area">
      <Input.TextArea
        allowClear
        rows={rows}
        value={value}
        onChange={onInputChange}
      />
      <div onClick={onGetText} className="input-text-area-ai">
        <img src="/ai.svg" />
        <span>Generate with AI</span>
      </div>
    </div>
  );
};

export default InputTextArea;
